import React, { useState, useEffect } from 'react'
import TopHeader from "../../Component/Header/TopHeader";
import {
  Container, Button, TextField, Typography, FormHelperText,
} from '@mui/material';
import { selectCurrenSigRole, setSigRoleDetails } from '../../app/features/sigSlice';
import { useUpdateSIGGroupProfileMutation } from '../../app/services/SIGGroupServices'
import { useSelector, useDispatch } from 'react-redux';
import { useForm, } from "react-hook-form";
import { toast } from "react-toastify";
import placeholder from '../../../src/assets/images/Profile/profile.jpg'
import { setImageUrl, selectImageUrl } from '../../app/auth/authSlice';
import ImageCropModal, { useImageCrop } from '../../Component/ImageCropModal/ImageCropModal';

const SigAdminProfile = () => {
  const sigRoleDetails = useSelector(selectCurrenSigRole);
  const dispatch = useDispatch();
  const imgSig = useSelector(setSigRoleDetails)
  const sigImageUrl = useSelector(selectImageUrl)
  const { cropModal, openCropModal, handleCropApply, closeCropModal } = useImageCrop();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    watch
  } = useForm()
  const [selectedImage, setSelectedImage] = useState(null);
  const [updateSigProfile] = useUpdateSIGGroupProfileMutation()
  // const [dirtys, setdirtys] = useState(false);
  const imageUrl = selectedImage
    || (watch("imageUrl") ? `${watch("imageUrl")}?t=${new Date().getTime()}` : null)
    || (sigImageUrl ? `${sigImageUrl}?t=${new Date().getTime()}` : null)
    || placeholder;

  //patch value  Sig details By id
  useEffect(() => {
    Object.entries(sigRoleDetails)?.forEach(([key, value]) => {
      setValue(key, value)
    })
  }, [setValue, sigRoleDetails])
  const findRoleDetailsById = (roles) => {
    const roleId = imgSig?.payload?.auth?.roleId;
    return roles.find(role => role._id === roleId);
  };

  const sigAdminUpdateProfile = (data) => {
    const base64Regex = /^data:image\/(?:png|jpeg|jpg|gif);base64,[\w+/=]+$/;

    const { payload } = imgSig || {};
    const { auth, sig } = payload || {};
    const roleId = auth?.roleId;
    const adminId = auth?.memberId;
    const sigId = sig?.sigDetails?._id;

    let imageUrl = "";
    if (base64Regex.test(data?.imageUrl)) {
      imageUrl = data.imageUrl;
    } else if (data?.imageUrl) {
      const parts = data.imageUrl.split("/");
      const filename = parts[parts.length - 1];
      imageUrl = filename ? `sigGroup/roleDetails/${filename}` : "";
    }
    const updateData = {
      id: sigId,
      formData: {
        name: data.name,
        email: data.email,
        address: data.address,
        mobile: data.mobile,
        imageUrl: imageUrl,
        role: "PORTAL_SIG_ADMIN",
        roleId,
        adminId,
      },
    };

    updateSigProfile(updateData)
      .then((res) => {
        const responseData = res?.data;
        if (responseData?.status) {
          toast.success(responseData.message);

          const updatedRoles = responseData?.data?.updateSigAdminDetailsData?.roleDetails;
          const matchedRole = findRoleDetailsById(updatedRoles);
          dispatch(setSigRoleDetails(matchedRole));

          const newImageUrl = responseData?.data?.updateAdminData?.imageUrl;
          dispatch(setImageUrl({ imageUrl: newImageUrl }));
        }
      })
      .catch((err) => {
        console.error("Error updating SIG Admin profile:", err);
        toast.error("Profile update failed. Please try again.");
      });
  };


  return (
    <div>
      <TopHeader />
      <div className='pt-lg-5 pt-3'>
        <div className='pt-1'>
          <div className=' Architects-header d-flex align-items-center justify-content-center '>
            <h2 className='title-font text-center '>SIG Profile</h2>
          </div>
        </div>

      </div>
      <Container maxWidth="xl" className='p-md-5 p-3 overallPadding'>
        <div className='text-end mb-3'>
          <Button
            onClick={() => window.history.back()}
            variant="contained"
            className="menus-color"
          >
            Back
          </Button>
        </div>
        <form onSubmit={handleSubmit(sigAdminUpdateProfile)}>
          <div className='row mb-3 pb-5'>
            {/* <div class="d-flex justify-content-center">
              <div>
                <img
                  src={selectedImage || watch("imageUrl") || placeholder}
                  height="100"
                  alt="eventform"
                  style={{
                    objectFit: "scale-down",
                    width: "200px",
                  }}
                />
                <TextField
                  sx={{ mt: 2 }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: "image/jpeg, image/png" }}
                  id="imageUrl"
                  label={
                    <Typography className="text-dark">
                      Image <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  style={{ display: 'none' }}
                  type="file"
                  {...register(`image`, {
                    required: { value: !watch(`imageUrl`), message: 'Please Select a Image' }, validate: (value) => {
                      const file = value[0];
                      if (!watch(`imageUrl`)) {
                        if (!file || !file.type.startsWith("image/")) {
                          setValue(`imageUrl`, "")
                          return "Please Select a image file"
                        }
                        if (file && file.size > 2 * 1024 * 1024) {
                          setValue(`imageUrl`, "")
                          return "File size exceeds 2mb"
                        }
                      }
                      return true;
                    }, onChange: (e) => handleImageChange(e),
                  })}
                />
                <label
                  htmlFor="imageUrl"
                  style={{ marginLeft: "10px" }}
                >
                  <Button
                    variant="contained"
                    className="menus-color"
                    component="span"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Choose File <span style={{ color: "white", paddingLeft: "5px" }}>*</span>
                  </Button>
                </label>
                {!!errors?.image && (
                  <div style={{ color: "red", marginTop: "10px" }}>
                    {errors?.image?.message}
                  </div>
                )}
              </div>
            </div> */}
            <div className='row mb-3 '>
              <div className='col-md-12 d-flex justify-content-center position-relative'>
                {/* Tooltip with Error Icon */}
                {/* <Tooltip title="Image dimensions must be between 140x140 and 150x150 pixels. Image must be .jpg, .jpeg, .png, .jfif">
                  <span>
                    <ErrorIcon
                      style={{
                        width: "30px",
                        height: '30px',
                        cursor: "pointer",
                        position: 'absolute',
                        top: "75%",
                        right: "49%",
                        color: "black",
                        backgroundColor: '#d3d3d3',
                        padding: "5px",
                        borderRadius: "50%"

                      }}
                    />
                  </span>
                </Tooltip> */}

                {/* Image Preview */}
                <img
                  src={imageUrl}
                  height="100"
                  alt="Profile"
                  style={{ objectFit: "scale-down", width: "200px" }}
                  key={watch("imageUrl")}
                />

                {/* Hidden File Input */}
                <TextField
                  sx={{ mt: 2 }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: "image/jpeg, image/png" }}
                  id="imageUrl"
                  type="file"
                  style={{ display: 'none' }}
                  {...register("image", {
                    required: !watch("imageUrl") && "Please Select an Image",
                    validate: (value) => {
                      if (!watch("imageUrl")) {
                        const file = value?.[0];
                        if (!file || !file.type.startsWith("image/")) return "Invalid image file";
                        if (file.size > 2 * 1024 * 1024) return "File size exceeds 2MB";
                      }
                      return true;
                    },
                    onChange: (e) => {
                      openCropModal(e, null, 2);
                    },
                  })}
                />

                {/* File Upload Button */}
                <label htmlFor="imageUrl" style={{ marginLeft: "10px", marginTop: '20px' }}>
                  <Button variant="contained" className="menus-color border-radius-membership-wallpage-button" component="span">
                    Choose File
                  </Button>
                </label>

                {/* Error Message */}
                <FormHelperText className="pt-3 image-error-membership-wall-profile-chapter" error={!!errors?.image}>{errors?.image?.message}</FormHelperText>
              </div>

            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <TextField
                InputLabelProps={{ shrink: true }}
                style={{ width: "100%" }}
                id="headline"
                label={
                  <Typography className="text-dark">
                    Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("name", {
                  required: "Please Enter Name",
                  maxLength: {
                    value: 35,
                    message: "Name cannot exceed 35 characters",
                  },
                })}
                error={!!errors?.name}
                helperText={errors?.name?.message}
              />
              <TextField className='mt-3'
                InputLabelProps={{ shrink: true }}
                style={{ width: "100%" }}
                id="headline"
                label={
                  <Typography className="text-dark">
                    Address
                  </Typography>
                }
                variant="outlined"
                {...register("address", {
                  // required: "Please Enter Address",
                })}
                error={!!errors?.address}
                helperText={errors?.address?.message}
              />
            </div>
            <div className='col-md-4'>
              <TextField
                style={{ width: "100%", }}
                InputLabelProps={{ shrink: true }}
                id="title"
                label={
                  <Typography className="text-dark">
                    Email <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("email", {
                  required: "Please Enter a email",
                  pattern: {
                    value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                    message: "Please Enter a valid Email",
                  },
                })}
                error={!!errors?.email}
                helperText={errors?.email?.message}
              />
            </div>
            <div className='col-md-4'>
              <TextField
                InputLabelProps={{ shrink: true }}
                style={{ width: "100%" }}
                id="headline"
                label={
                  <Typography className="text-dark">
                    Mobile
                  </Typography>
                }
                variant="outlined"
                {...register("mobile", {
                  // required: "Please Enter Phone",
                  pattern: {
                    value: /^[0-9]{10}$/, // Adjust the regex to your desired format
                    message: "Please enter a valid 10-digit phone number"
                  }
                })}
                error={!!errors?.mobile}
                helperText={errors?.mobile?.message}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 5,
            }}
          >
            <Button
              variant="contained"
              className="menus-color"
              type="submit"
              sx={{ mr: 3 }}
            >
              Update
            </Button>
          </div>
        </form>
        <ImageCropModal
          open={cropModal.open}
          imageSrc={cropModal.src}
          outputWidth={140}
          outputHeight={140}
          title="Crop Profile Image"
          onCancel={closeCropModal}
          onCrop={(base64) => {
            handleCropApply(base64, (b64) => {
              setSelectedImage(b64);
              setValue("imageUrl", b64, { shouldValidate: true, shouldDirty: true });
              clearErrors("image");
            });
          }}
        />
      </Container>
    </div>
  )
}

export default SigAdminProfile